import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-layout",
    template: `
        <museum-header></museum-header>
        <app-navigation-bar></app-navigation-bar>
        <router-outlet></router-outlet>
    `,
    styleUrls: ["../../block.scss"],
})
export class LayoutComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
